export default "__VITE_ASSET__DaAWaZuA__"